export default [
  {
    path: '/prudutos',
    name: 'app-adm-produtos',
    component: () => import('@/views/apps/produtos/list/ItemProdutoList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Produto',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listagem Produtos',
          active: true,
        },
        {
          text: 'Cadastrar produto',
          active: false,
          to: {
            name: 'app-adm-produto-add',
          },
        },
      ],
    },
  },
  {
    path: '/afiliacoes',
    name: 'app-afiliado-produtos',
    component: () => import('@/views/apps/produtos/list/ItemProdutoAfiliadoList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Afiliações',
      action: 'read',
      resource: 'Afiliado',
      breadcrumb: [
        {
          text: 'Lista de Afiliações',
          active: true,
        },
        {
          text: 'Produtos',
          active: false,
          to: {
            name: 'app-adm-produto-afiliado-add',
          },
        },
      ],
    },
  },
  {
    path: '/gerenciar-afiliacoes',
    name: 'app-afiliado-afiliacoes',
    component: () => import('@/views/apps/produtos/list/ItemGerenciarList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Afiliados',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Gerenciar',
          active: true,
        },
        {
          text: 'Solicitações',
          active: false,
          to: {
            name: 'app-adm-gerenciar-afiliado-add',
          },
        },
      ],
    },
  },
  {
    path: '/add-produto/:id?',
    name: 'app-adm-produto-add',
    component: () => import('@/views/apps/produtos/edit/Edit.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Produto',
      action: 'update',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Lista de Produtos',
          active: false,
          to: {
            name: 'app-adm-produtos',
          },
        },
        {
          text: 'Cadastrar Produto',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-produto-afiliado/:id?',
    name: 'app-adm-produto-afiliado-add',
    component: () => import('@/views/apps/produtos/edit/afiliado/EditAfiliado.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Produto',
      action: 'update',
      resource: 'Afiliado',
      breadcrumb: [
        {
          text: 'Lista de Afiliações',
          active: false,
          to: {
            name: 'app-afiliado-produtos',
          },
        },
        {
          text: 'Produtos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-gerenciar-afiliado/:id?',
    name: 'app-adm-gerenciar-afiliado-add',
    component: () => import('@/views/apps/produtos/edit/EditGerenciar.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Produto',
      action: 'update',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Gerenciar',
          active: false,
          to: {
            name: 'app-afiliado-afiliacoes',
          },
        },
        {
          text: 'Solicitações',
          active: true,
        },
      ],
    },
  },
  {
    path: '/visualizar-produto/:id?',
    name: 'app-adm-produto-view',
    component: () => import('@/views/apps/produtos/details/ItemDetails.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Produto',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Listar Produto',
          active: false,
          to: {
            name: 'app-adm-produtos',
          },
        },
        {
          text: 'Visualizar Produto',
          active: true,
        },
      ],
    },
  },
]
